<ng-container *ngIf="isVisible">
  <div
    [ngClass]="{
      'opacity-100 pointer-events-auto': !isFadingOut,
      'opacity-0 pointer-events-none transition-opacity duration-300 ease-in-out': isFadingOut,
    }"
    class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 backdrop-blur-sm transition-opacity duration-300 ease-in-out"
  >
    <div class="text-white text-xl animate-pulse">Loading...</div>
    <div
      class="ml-4 w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"
    ></div>
  </div>
</ng-container>
